import { DataDescribed }        from '../data-described/data-described.model';
import { LayoutAnnotationForm } from './layout-annotation-form.model';

export class FormDataDescribed<T> extends DataDescribed<T, LayoutAnnotationForm<T>> {

}

